import { Link } from "react-router-dom";
import { site } from "@/mocks/site";
import { categories } from "@/mocks/categories";
import SearchBox from "./SearchBox";

export default function Hero() {
  return (
    <section className="relative w-full bg-gradient-to-b from-background-100 via-background-50 to-background-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-12 lg:py-16">
        <div className="flex flex-col items-start justify-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
            <i className="ri-megaphone-line text-sm"></i>
            分类浏览指南 · 吃瓜高效不迷路
          </span>
          <h1 className="mt-5 font-heading text-4xl leading-tight font-black tracking-tight text-foreground-950 md:text-5xl lg:text-[54px]">
            不再大海捞针，
            <br />
            把热点<span className="text-primary-500">分门别类</span>给你
          </h1>
          <p className="mt-5 max-w-xl text-base leading-7 text-foreground-600 md:text-lg">
            {site.desc} 想看哪类直接进对应分类，话题、事件、人物与机构，一条不落。
          </p>
          <div className="mt-7 w-full max-w-xl">
            <SearchBox />
          </div>
          <div className="mt-6 flex flex-wrap gap-2.5">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
              >
                <i className={`${c.icon} text-base text-primary-500`}></i>
                {c.name}
                <span className="text-xs text-foreground-400">{c.stat}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* 右侧：今日速览卡片区 */}
        <div className="relative hidden lg:flex lg:items-center lg:justify-center">
          <div className="relative w-full max-w-md rounded-xl border border-background-200/70 bg-background-100 p-5">
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-1.5 text-sm font-bold text-foreground-950">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75"></span>
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-500"></span>
                </span>
                今日速览
              </span>
              <span className="text-xs text-foreground-500">实时更新</span>
            </div>
            <div className="mt-4 space-y-3">
              {[
                { k: '话题', v: '信息断舍离', n: '+128%' },
                { k: '事件', v: '笔记App登顶周榜', n: '热榜第一' },
                { k: '人物', v: '内容策展人走红', n: '新锐' },
              ].map((r) => (
                <div key={r.k} className="flex items-center gap-3 rounded-lg border border-background-200/60 bg-background-50 px-4 py-3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-100 text-sm font-bold text-primary-700">
                    {r.k}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-900">{r.v}</span>
                  <span className="shrink-0 text-xs font-semibold whitespace-nowrap text-accent-700">{r.n}</span>
                </div>
              ))}
            </div>
            <div className="mt-4 flex items-center justify-between rounded-lg bg-secondary-100 px-4 py-3">
              <span className="text-sm text-secondary-800">累计整理内容</span>
              <span className="font-heading text-2xl font-black text-primary-600">2,486<span className="text-sm font-bold text-secondary-700"> 条</span></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}